var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "deliveryConfirm" } },
    [
      _c("dd-header", { attrs: { isMenuView: false } }),
      _vm._v(" "),
      _c("dd-sitemap", {
        attrs: { pageKey: _vm.pageKey, pageList: _vm.topForm.pageList }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("section", { attrs: { id: "researchPlace" } }, [
          _c("h3", [_vm._v("調査依頼場所")]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "input_confirm3" }, [
              _c("ul", [
                _c("li", [
                  _c("span", [_vm._v("施主名（物件名）")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.resrchData.businessName))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("調査物件名：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.resrchData.building))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("郵便番号：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.resrchData.postcd))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("住所：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.resrchData.state) +
                        " " +
                        _vm._s(_vm.resrchData.city) +
                        " " +
                        _vm._s(_vm.resrchData.street)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("立会人氏名：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.resrchData.userLastName) +
                        " " +
                        _vm._s(_vm.resrchData.userFirstName)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("立会人氏名(カナ)：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.resrchData.userLastNameKana) +
                        " " +
                        _vm._s(_vm.resrchData.userFirstNameKana)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("立会人電話番号：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.resrchData.tel))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("立会人への直接連絡：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.resrchData.contactFlag ? "あり" : "なし"))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { attrs: { id: "resrchCost" } }, [
          _c("h3", [_vm._v("お見積り金額")]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "input_confirm3" }, [
              _c("ul", [
                _c("li", [
                  _c("span", [_vm._v("事前調査費用：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.formatPrice(_vm.values.price)))
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("div", [_vm._v("消費税：")]),
                  _vm._v(" "),
                  _c("div", [_vm._v(_vm._s(_vm.formatPrice(_vm.values.tax)))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("div", [_vm._v("合計：")]),
                  _vm._v(" "),
                  _c("div", [
                    _vm._v(_vm._s(_vm.formatPrice(_vm.values.totalPrice)))
                  ])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { attrs: { id: "resrchInfo" } }, [
          _c("h3", [_vm._v("事前調査内容")]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "sub_title" }, [_vm._v("1.専有部分")]),
            _vm._v(" "),
            _c("div", { staticClass: "input_confirm3" }, [
              _c("ul", [
                _c("li", [
                  _c("span", [_vm._v("設置場所の採寸:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.priPosition))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("設置場所の下地確認:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.priGround))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("コンセント・PS等壁設置物確認:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.priPlug))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("照明・自火報等天井設置物確認:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.priCeiling))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("搬入経路の有効寸法確認:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.priCarryRoute))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("その他確認事項:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.priConfComment))])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "sub_title" }, [_vm._v("2.共有部分")]),
            _vm._v(" "),
            _c("div", { staticClass: "input_confirm3" }, [
              _c("ul", [
                _c("li", [
                  _c("span", [_vm._v("トラック停車位置:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.pubTruckPark))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("搬入経路:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.pubCarryRoute))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("エレベーターサイズ:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.pubElevator))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("搬入施工時の事前申請:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.pubRequest))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("共有部養生の有無:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.pubCuring))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("駐車場の有無:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.pubParking))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("その他確認事項:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.pubConfComment))])
                ])
              ]),
              _vm._v(" "),
              _c("ul", [
                _c("li", [
                  _c("span", [_vm._v("その他コメント:")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.otherComment))])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { attrs: { id: "resrchDays" } }, [
          _c("h3", [_vm._v("事前調査希望日")]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "input_confirm3" }, [
              _c("ul", [
                _c("li", [
                  _c("span", [_vm._v("第一希望日：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.values.pref1Val) +
                        " " +
                        _vm._s(_vm.values.pref1TimeVal)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("第二希望日：")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.values.pref2Val) +
                        " " +
                        _vm._s(_vm.values.pref2TimeVal)
                    )
                  ])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("その他日程調整希望：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.scheduleComment))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("依頼人の立ち合い：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.observer))])
                ]),
                _vm._v(" "),
                _c("li", [
                  _c("span", [_vm._v("調査先への入室方法：")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.values.entranceComment))])
                ])
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { attrs: { id: "pre_confirm" } }, [
          _c("h3", [_vm._v("確認事項")]),
          _vm._v(" "),
          _c("div", [
            _c("div", { staticClass: "input_confirm" }, [
              _c("div", { staticClass: "check_box" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.confirmUseRule,
                      expression: "confirmUseRule"
                    }
                  ],
                  attrs: { type: "checkbox", id: "confirmUseRule" },
                  domProps: {
                    checked: Array.isArray(_vm.confirmUseRule)
                      ? _vm._i(_vm.confirmUseRule, null) > -1
                      : _vm.confirmUseRule
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.confirmUseRule,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.confirmUseRule = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.confirmUseRule = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.confirmUseRule = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "confirmUseRule" } }, [
                  _c(
                    "a",
                    { staticClass: "link" },
                    [
                      _c(
                        "router-link",
                        {
                          staticClass: "link",
                          attrs: {
                            to: "/mmstyle/user/use-rule",
                            target: "_blank"
                          }
                        },
                        [_vm._v("利用規約")]
                      )
                    ],
                    1
                  ),
                  _vm._v("に同意して、購入する。")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "check_box" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.confirmItem,
                      expression: "confirmItem"
                    }
                  ],
                  attrs: { type: "checkbox", id: "confirmItem" },
                  domProps: {
                    checked: Array.isArray(_vm.confirmItem)
                      ? _vm._i(_vm.confirmItem, null) > -1
                      : _vm.confirmItem
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.confirmItem,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 && (_vm.confirmItem = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.confirmItem = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.confirmItem = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c("label", { attrs: { for: "confirmItem" } }, [
                  _vm._v("調査依頼内容に間違いがないことを確認しました。")
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "check_box" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.confirmOrderDeliCancel,
                      expression: "confirmOrderDeliCancel"
                    }
                  ],
                  attrs: { type: "checkbox", id: "confirmOrderDeliCancel" },
                  domProps: {
                    checked: Array.isArray(_vm.confirmOrderDeliCancel)
                      ? _vm._i(_vm.confirmOrderDeliCancel, null) > -1
                      : _vm.confirmOrderDeliCancel
                  },
                  on: {
                    change: function($event) {
                      var $$a = _vm.confirmOrderDeliCancel,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            (_vm.confirmOrderDeliCancel = $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            (_vm.confirmOrderDeliCancel = $$a
                              .slice(0, $$i)
                              .concat($$a.slice($$i + 1)))
                        }
                      } else {
                        _vm.confirmOrderDeliCancel = $$c
                      }
                    }
                  }
                }),
                _vm._v(" "),
                _c(
                  "label",
                  {
                    staticClass: "emphasis",
                    attrs: { for: "confirmOrderDeliCancel" }
                  },
                  [
                    _vm._v(
                      "注文後の事前調査希望日、及び事前現場調査先を変更することはできません。"
                    )
                  ]
                )
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("section", { attrs: { id: "form_button" } }, [
          _c("div", { staticClass: "control_btn_area" }, [
            _c(
              "div",
              {
                staticClass: "detail_btn2",
                on: {
                  click: function($event) {
                    _vm.goBack()
                  }
                }
              },
              [_vm._v("〈〈   戻る   ")]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                class: { detail_btn: true, disabled: _vm.isOrderDisable },
                on: {
                  click: function($event) {
                    _vm.confirm()
                  }
                }
              },
              [_vm._v("注文する")]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("dd-footer"),
      _vm._v(" "),
      _c("dd-loading-modal", { ref: "loadingModalRef" })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "title" }, [
      _c("h1", [_vm._v("事前現場調査内容確認画面")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4e4e62a5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e4e62a5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/payment/pages/DcBuildingResearchConfirm.vue
// module id = null
// module chunks = 